import { useState, useEffect } from "react";

import { useServerData } from "@hooks";
import { usePropertyListingsLazyQuery } from "@gql";
import { Loader } from "@components/Loader";
import { CREATerms } from "@components/CreaTerms";

import * as styles from "./PropertyListingTiles.styles";
import { PropertyListingTile } from "./PropertyListingTile";

interface Props {
  listingAgentKeys: string[];
}

const PropertyListingTiles = ({ listingAgentKeys }: Props) => {
  const { acceptedTerms: defaultAcceptedTerms } = useServerData();
  const [acceptedTerms, setAcceptedTerms] = useState(defaultAcceptedTerms);

  const [loadListings, { called, loading, data }] = usePropertyListingsLazyQuery({
    variables: {
      filter: {
        listingAgentKeys,
      },
    },
  });

  useEffect(() => {
    if (acceptedTerms) {
      loadListings();
    }
  }, [acceptedTerms]);

  return (
    <div css={styles.propertyListingTiles} data-testid="propertyListingTiles">
      {!acceptedTerms && (
        <div className="row">
          <CREATerms onAccepted={() => setAcceptedTerms(true)} />
        </div>
      )}

      <Loader css={styles.loader} loading={loading && acceptedTerms} />

      {!loading && called && acceptedTerms && (
        <div css={styles.propertylistingTilesContainer}>
          {data?.propertyListings?.map(p => <PropertyListingTile key={p.id} propertyListing={p} />)}
        </div>
      )}
    </div>
  );
};

export { PropertyListingTiles };
